// extracted by mini-css-extract-plugin
export var hasTextWeightBold = "Header-module--has-text-weight-bold--2e240";
export var headerContainer = "Header-module--headerContainer--7c54b";
export var international = "Header-module--international--80734";
export var invertImage = "Header-module--invertImage--1acec";
export var isNavigationVisible = "Header-module--isNavigationVisible--006e2";
export var isUppercase = "Header-module--is-uppercase--0120c";
export var langSelectorContainer = "Header-module--langSelectorContainer--e539f";
export var languageCode = "Header-module--languageCode--ee1e2";
export var languageContent = "Header-module--languageContent--9f33b";
export var languageContentDisplay = "Header-module--languageContentDisplay--65b78";
export var languageContentHide = "Header-module--languageContentHide--3cecf";
export var languageDropdown = "Header-module--languageDropdown--5842e";
export var languageOption = "Header-module--languageOption--429c1";
export var localeDropDownIcon = "Header-module--locale-dropDown-icon--e841e";
export var localeOptions = "Header-module--locale-options--d77f8";
export var locationDropdown = "Header-module--location-dropdown--31e6c";
export var locationDropdownIcon = "Header-module--location-dropdown-icon--7b411";
export var locationDropdownLabel = "Header-module--location-dropdown-label--37b12";
export var locationHelperText = "Header-module--locationHelperText--fcaa0";
export var menu = "Header-module--menu--8c2df";
export var mobileContainer = "Header-module--mobileContainer--149b6";
export var mobilePromotionContainer = "Header-module--mobilePromotionContainer--10fa8";
export var navbarItem = "Header-module--navbar-item--eeb76";
export var navbarMenu = "Header-module--navbarMenu--a9115";
export var navigation = "Header-module--navigation--acbc9";
export var overhead = "Header-module--overhead--2c3b6";
export var overheadInner = "Header-module--overhead-inner--78d2f";
export var productDropdownContent = "Header-module--productDropdownContent--279ac";
export var productDropdownIcon = "Header-module--productDropdownIcon--7dd19";
export var promotionContainer = "Header-module--promotionContainer--3f018";
export var root = "Header-module--root--6d142";
export var routeAvailable = "Header-module--routeAvailable--89a3a";
export var routeNotAvailable = "Header-module--routeNotAvailable--6e32f";
export var rtlTemplate = "Header-module--rtlTemplate--21fff";
export var studentLoginLink = "Header-module--studentLoginLink--3b081";
export var telephoneLink = "Header-module--telephoneLink--7c9e9";
export var topBarCta = "Header-module--topBarCta--c6272";
export var topBarLinks = "Header-module--top-bar-links--d9697";
export var wrapper = "Header-module--wrapper--ed1d5";